import React, { useMemo } from 'react';
import Tooltip from 'antd/lib/tooltip';
import { toAllowedStringLength } from '../common/formattersToAllowedValueLength';
import { useEmailUtilityAutomationListQuery } from '../email-utility-automation/queries';
import { useCloudVenListQuery } from '../ven/queries';
import { useAuth } from '../auth/useAuth';

export function useProgramUtilityAutomationFilterOptions(companyId?: number) {
    const auth = useAuth();

    const isQueryData = auth?.user?.isAdminRoleType();

    const { data: emailUtilityAutomationsData } = useEmailUtilityAutomationListQuery({}, { enabled: isQueryData });
    const { data: cloudVensData } = useCloudVenListQuery(
        {
            company_id: companyId ?? null,
            onlyAttachedToPrograms: true,
        },
        { enabled: isQueryData }
    );

    const emailUtilityAutomationFilterOptions = useMemo(() => {
        const emailUtilityAutomations = emailUtilityAutomationsData || [];

        return emailUtilityAutomations.map(emailUtilityAutomation => ({
            text: emailUtilityAutomation.title,
            value: emailUtilityAutomation.automation_key,
        }));
    }, [emailUtilityAutomationsData]);

    const cloudVenFilterOptions = useMemo(() => {
        const cloudVens = cloudVensData?.data || [];

        return cloudVens.map(cloudVen => ({
            text: (
                <Tooltip placement="right" title={cloudVen.ven_id}>
                    {toAllowedStringLength(`[Cloud VEN] - ${cloudVen.ven_id}`)}
                </Tooltip>
            ),
            value: cloudVen.ven_id,
        }));
    }, [cloudVensData]);

    return [...emailUtilityAutomationFilterOptions, ...cloudVenFilterOptions];
}
